import { render, staticRenderFns } from "./GenericTHGCarTable.vue?vue&type=template&id=745589e8&scoped=true"
import script from "./GenericTHGCarTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./GenericTHGCarTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GenericTHGCarTable.vue?vue&type=style&index=0&id=745589e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745589e8",
  null
  
)

export default component.exports